import { useEffect } from 'react';
import { Box, Text } from '@nimbus-ds/components';
import { StatsIcon } from '@nimbus-ds/icons';
import { Trans } from 'react-i18next';
import { useControlCta } from 'commons/hooks/useControlCta';
import { trackingNuvemPagoNudgesAlertTipView } from 'domains/Payments/tracking';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

interface NuvemPagoAdoptAlertTipProps {
  readonly isActive: boolean | undefined;
}

export function NuvemPagoAdoptAlertTip({
  isActive,
}: Readonly<NuvemPagoAdoptAlertTipProps>) {
  const t = useTranslationPayments();
  const { isCalloutVisible, group } = useControlCta();
  const isVisible = !isActive && isCalloutVisible;

  useEffect(() => {
    if (isVisible) trackingNuvemPagoNudgesAlertTipView(group);
  }, [isVisible, group]);

  if (!isVisible) return null;

  return (
    <Box
      data-testid="nuvem-pago-adopt-alert-tip"
      display="flex"
      flexDirection="row"
      gap="2"
      justifyContent="flex-start"
      alignItems="center"
      backgroundColor="primary-surface"
      width="100%"
      padding="2"
      borderRadius="2"
    >
      <Box
        backgroundColor="primary-surfaceHighlight"
        borderRadius="1"
        padding="1"
        paddingBottom="0-5"
      >
        <StatsIcon size="small" color="primary-textLow" />
      </Box>
      <Text color="primary-textLow">
        <Trans
          t={t}
          i18nKey="paymentFeaturesCard.nuvempago_AlertTipText"
          components={{
            b: <b className="text-primary-textLow" />,
          }}
        />
      </Text>
    </Box>
  );
}
